import { useState, useRef } from "react";
import { SECTIONS, GALLERY_CATS, Icon } from "../AdminPanel";
import { useApi } from "../AdminPanel";

export default function UploadPage({ token, toast, onExpired }) {
  const { upload } = useApi(token, onExpired);
  const fileRef = useRef();
  const [files, setFiles]         = useState([]);
  const [drag, setDrag]           = useState(false);
  const [uploading, setUploading] = useState(false);
  const [metas, setMetas]         = useState([]);

  const addFiles = (incoming) => {
    const arr = Array.from(incoming).filter(f => f.type.startsWith("image/"));
    const newMetas = arr.map(f => ({
      preview:     URL.createObjectURL(f),
      section:     "gallery",
      title:       f.name.replace(/\.[^.]+$/, "").replace(/[-_]/g, " "),
      description: "",
      category:    "",
      sort_order:  0,
    }));
    setFiles(prev => [...prev, ...arr]);
    setMetas(prev => [...prev, ...newMetas]);
  };

  const updateMeta = (i, key, val) =>
    setMetas(prev => prev.map((m, idx) => idx === i ? { ...m, [key]: val } : m));

  const removeFile = (i) => {
    setFiles(prev => prev.filter((_, idx) => idx !== i));
    setMetas(prev => prev.filter((_, idx) => idx !== i));
  };

  const handleUpload = async () => {
    if (!files.length) return;
    setUploading(true);
    let ok = 0, fail = 0;
    for (let i = 0; i < files.length; i++) {
      const fd = new FormData();
      fd.append("file",        files[i]);
      fd.append("section",     metas[i].section);
      fd.append("title",       metas[i].title);
      fd.append("description", metas[i].description || "");
      fd.append("category",    metas[i].category || "");
      fd.append("sort_order",  String(metas[i].sort_order));
      try   { await upload("/images/upload", fd); ok++; }
      catch { fail++; }
    }
    setUploading(false);
    if (ok)   { toast(`Загружено: ${ok} файл(ов)`, "success"); setFiles([]); setMetas([]); }
    if (fail) { toast(`Ошибок: ${fail}`, "error"); }
  };

  return (
    <div>
      <div className="adm-eyebrow">Медиабиблиотека</div>
      <h1 style={{ fontFamily: "'Oswald', sans-serif", fontSize: 32, fontWeight: 400, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 28 }}>
        Загрузка изображений
      </h1>

      <div
        className={`adm-dropzone${drag ? " drag" : ""}`}
        onClick={() => fileRef.current.click()}
        onDragOver={e  => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={e => { e.preventDefault(); setDrag(false); addFiles(e.dataTransfer.files); }}
      >
        <div className="adm-dropzone__icon">{Icon.Upload}</div>
        <div className="adm-dropzone__text">Перетащите файлы или нажмите для выбора</div>
        <div className="adm-dropzone__hint">JPEG, PNG, WEBP, GIF — до 10 МБ каждый</div>
        <input ref={fileRef} type="file" accept="image/*" multiple style={{ display: "none" }}
          onChange={e => addFiles(e.target.files)} />
      </div>

      {files.length > 0 && (
        <>
          <div className="adm-sep"><span>{files.length} файл(ов) в очереди</span></div>
          <div className="adm-queue">
            {files.map((f, i) => (
              <div key={i} className="adm-queue-item">
                <img src={metas[i].preview} className="adm-queue-thumb" alt="" />
                <div className="adm-queue-meta">
                  <div className="adm-queue-filename">{f.name}</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
                    <div className="adm-field">
                      <label className="adm-label">Блок</label>
                      <select className="adm-select" value={metas[i].section} onChange={e => updateMeta(i, "section", e.target.value)}>
                        {SECTIONS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                      </select>
                    </div>
                    <div className="adm-field">
                      <label className="adm-label">Заголовок</label>
                      <input className="adm-input" value={metas[i].title} onChange={e => updateMeta(i, "title", e.target.value)} />
                    </div>
                    <div className="adm-field">
                      <label className="adm-label">Категория</label>
                      {metas[i].section === "gallery" ? (
                        <select className="adm-select" value={metas[i].category} onChange={e => updateMeta(i, "category", e.target.value)}>
                          <option value="">— выберите —</option>
                          {GALLERY_CATS.map(c => <option key={c} value={c}>{c}</option>)}
                        </select>
                      ) : (
                        <input className="adm-input" value={metas[i].category} onChange={e => updateMeta(i, "category", e.target.value)} placeholder="опционально" />
                      )}
                    </div>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 8, alignItems: "center" }}>
                    <input className="adm-input" placeholder="Описание (необязательно)" value={metas[i].description}
                      onChange={e => updateMeta(i, "description", e.target.value)} />
                    <button className="adm-btn adm-btn--danger adm-btn--sm" onClick={() => removeFile(i)}>{Icon.Trash}</button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
            <button className="adm-btn" onClick={() => { setFiles([]); setMetas([]); }}>Очистить</button>
            <button className="adm-btn adm-btn--primary" onClick={handleUpload} disabled={uploading}>
              {uploading ? <span className="adm-spinner" /> : Icon.Upload}
              {uploading ? "Загрузка..." : `Загрузить ${files.length} файл(ов)`}
            </button>
          </div>
        </>
      )}
    </div>
  );
}